/** Cross-origin iframe helpers for persisting auth when localStorage is blocked. */

export function isEmbeddedInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export async function requestIframeStorageAccess(): Promise<void> {
  if (!isEmbeddedInIframe() || !document.requestStorageAccess) {
    return;
  }

  try {
    if (document.hasStorageAccess && (await document.hasStorageAccess())) {
      return;
    }

    await document.requestStorageAccess();
  } catch {
    // User denied or browser does not grant access; fallbacks handle persistence.
  }
}
